import Analytics from 'analytics'
import googleTagManager from '@analytics/google-tag-manager'
import { originalSourcePlugin } from '@analytics/original-source-plugin'
import Clarity from '@microsoft/clarity';
import axios from 'axios'
import { router } from '@inertiajs/vue3'

export function initAnalytics(clarityId, infernalGtmId) {

    axios.interceptors.request.use((config) => {
        const lang = document?.documentElement?.lang;
        if (lang) {
            config.headers['Accept-Content-Language'] = lang;
            config.headers['Accept-Language'] = lang;
        }
        config.headers['Original-Source'] = localStorage.getItem('__user_original_source');

        return config;
    });

    if (__APP_ENV__ === 'production' || __ANALYTICS_DEBUG__) {
        Clarity.init(clarityId)
        if (getMetaValue('user-uuid')) {
            Clarity.identify(getMetaValue('user-uuid'))
        }
        if (getMetaValue('tenant')) {
            Clarity.setTag('tenant', getMetaValue('tenant'))
        }
    }
    if (getGtmValues(infernalGtmId)) {
        let gtmPlugins = [originalSourcePlugin()]
        getGtmValues(infernalGtmId).forEach(containerId => {
            let uniqueId = containerId.replace('GTM-', '')
            uniqueId = 'google-tag-manager-' + uniqueId
            const GTM = Object.assign({}, googleTagManager({
                containerId: containerId,
                enabled: __APP_ENV__ === 'production' || __ANALYTICS_DEBUG__,
                debug: __ANALYTICS_DEBUG__
            }), {
                name: uniqueId
            })
            gtmPlugins.push(GTM)
        })

        let gtmContainer = Analytics({
            app: 'Alfred',
            version: __APP_VERSION__,
            debug: __ANALYTICS_DEBUG__,
            plugins: gtmPlugins
        })
        if (getMetaValue('user-uuid')) {
            gtmContainer.identify({
                id: getMetaValue('user-uuid')
            })

            router.on('navigate', event => {
                const pageDetails = {
                    url: event.detail.page.url,
                    title: event.detail.page.props?.analyticsRouteTitle ?? route().current(),
                }
                gtmContainer.page(pageDetails)
            })
            globalThis.gtmContainer = gtmContainer
        }
    }

}
function getGtmValues(infernalGtmId) {
    const metaTags = document.getElementsByTagName('meta')
    const gtms = [
        infernalGtmId
    ]
    for (const element of metaTags) {
        const metaTag = element
        if (metaTag.getAttribute('name') === 'gtm') {
            gtms.push(metaTag.getAttribute('content'))
        }
    }
    return gtms
}

function getMetaValue(name) {
    const metaTags = document.getElementsByTagName('meta')
    for (const element of metaTags) {
        const metaTag = element
        if (metaTag.getAttribute('name') === name) {
            return metaTag.getAttribute('content')
        }
    }
    return null
}